import React from 'react';
import { KatAlert } from '@amzn/katal-react';
import { useTranslation } from 'src/utils';
import { PostBanner } from '../../types/DiscussionPost';

interface PostBannersProps {
  banners: Array<PostBanner>;
  isAuthor: boolean;
  // eslint-disable-next-line react/require-default-props
  isNotGroupMember?: boolean;
}

enum OtherPostBanner {
  notGroupMember = 'NOT_GROUP_MEMBER',
}
type BannerList = Array<{
  type: PostBanner | OtherPostBanner,
  header: string,
  description: string,
  variant: KatAlert.Variant
}>;
const PostBanners: React.FC<PostBannersProps> = ({ banners, isAuthor, isNotGroupMember }) => {
  const { t } = useTranslation();
  let bannersList: BannerList = [
    {
      type: PostBanner.lockedThread,
      header: t('alert_lockedThreadHeader'),
      description: t('alert_lockedThreadDescription'),
      variant: 'info',
    },
  ];

  if (isAuthor) {
    bannersList = [
      ...bannersList,
      {
        type: PostBanner.personInformation,
        header: t('alert_piiHeader'),
        description: t('alert_piiDescription'),
        variant: 'warning',
      },
      {
        type: PostBanner.inappropriateContent,
        header: t('alert_inappropriateContentHeader'),
        description: t('alert_inappropriateContentDescription'),
        variant: 'warning',
      },
    ];
  }

  bannersList = bannersList.filter((banner) => banners.includes(banner.type as PostBanner));

  if (isNotGroupMember) {
    bannersList.push({
      type: OtherPostBanner.notGroupMember,
      header: t('notGroupMember_header'),
      description: t('notGroupMember_description'),
      variant: 'info',
    });
  }

  const displayBanners = bannersList
    .map((banner) => (
      <KatAlert
        key={banner.type}
        variant={banner.variant}
        className="mb-1"
        persistent
        header={banner.header}
        description={banner.description}
      />
    ));

  return <div data-testid="post-warnings" className="mb-5">{displayBanners}</div>;
};

export default PostBanners;
